export default "__VITE_ASSET__BT2232C1__"